import { Button, IconButton, Modal, Typography } from "@mui/material";
import { CrossIcon } from "../Plans/icons/GPTIcons/CrossIcon";
import LoadingButton from "./LoadingButton";

type DeleteModalProps = {
  open: boolean;
  handleDelete: () => void;
  handleCloseWarning: () => void;
  mainText: string;
  subText?: string;
  isDeleting?: boolean;
};
const DeleteModal = ({ open, handleDelete, handleCloseWarning, mainText, subText, isDeleting = false }: DeleteModalProps) => {
  return (
    <Modal open={open}>
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 shadow w-modal-mobile sm:w-modal-md md:w-modal-lg rounded-lg p-6 bg-white text-mui-black-87 dark:bg-background/paper-elevation-16 dark:text-white">
        <div className="flex flex-col gap-y-6">
          <div className="flex justify-between items-center">
            <Typography variant="h6/medium-500" className="text-mui-black-87 dark:text-white">
              {mainText}
            </Typography>
            <IconButton
              size="small"
              onClick={handleCloseWarning}
              className="cross-icon"
            >
              <CrossIcon className="fill-current" />
            </IconButton>
          </div>

          <>
            <div className="text-sm">
              {subText}
            </div>
            <div className="flex flex-col gap-y-4 md:flex-row gap-x-6 justify-center">

              <Button
                variant="outlined"
                size="large"
                fullWidth
                className="button-outlined"
                onClick={handleCloseWarning}
              >
                Cancel
              </Button>
              <LoadingButton
                variant="contained"
                size="large"
                fullWidth
                colorClass="!bg-error-main hover:!bg-error-main"
                onClick={handleDelete}
                isLoading={isDeleting}
              >
                Confirm deletion
                {" "}
              </LoadingButton>
            </div>
          </>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteModal;
